const SECS_IN_HOUR = 3600; // 60 * 60
const SECS_IN_MIN  = 60;
const MINS_IN_HOUR = 60;
const HOURS_IN_DAY = 24;
const SECS_IN_SEC  = 1;

/**
 * Convert a '00:00:00' tiem string into seconds
 *
 * @param {String} time time
 * @return {number} time
 */
export default function timeCodeToSeconds(time) {
   // 00:00:00 HH:MM:SS
   // 00:00    MM:SS
   // 00       SS
   const parts = time.split(':');
   const multiples = [SECS_IN_HOUR, SECS_IN_MIN, SECS_IN_SEC];
   let seconds = 0;

   while (parts.length && multiples.length) {
      seconds += parts.pop() * multiples.pop();
   }

   return seconds;
}

export function secondsToTime(seconds, showHours = false, showMS = false) {
   const ms = Math.round(seconds * 1000) % 1000;
   seconds = Math.floor(seconds);
   const multiples = showHours ? [HOURS_IN_DAY, MINS_IN_HOUR, SECS_IN_MIN] : [MINS_IN_HOUR, SECS_IN_MIN];

   const parts = [];
   while (multiples.length) {
      const koeff = multiples.pop();
      parts.unshift(pad(seconds % koeff));
      seconds = Math.floor(seconds / koeff);
   }
   return showMS ? parts.join(':') + '.' + ms : parts.join(':');
}

function pad(n) {
   return n < 10 ? `0${n}` : `${n}`;
}
